import React from 'react';
import { Flex, Text, Box } from 'pcln-design-system';
import { Check } from 'pcln-icons';
const Amenities = ({
  amenitiesList
}) => {
  return React.createElement(Box, {
    mt: 1
  }, (amenitiesList === null || amenitiesList === void 0 ? void 0 : amenitiesList.length) && amenitiesList.map((amenity, i) => {
    return React.createElement(Flex, {
      alignItems: 'center',
      key: `NewHotelListingsAmenities-${i}-${Math.random() * 100}`
    }, React.createElement(Check, {
      size: 20,
      color: 'secondary.base'
    }), React.createElement(Text, {
      ml: 1,
      fontSize: 0,
      lineHeight: '16px'
    }, amenity));
  }));
};
export default Amenities;